import React, { useState } from 'react';
import { useLocation } from 'react-router-dom'
import '../assests/css/Navbar.css'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import logo from "../assests/images/white-logo.png"
//toaster
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useHistory } from "react-router-dom";
import { FaRegUserCircle } from 'react-icons/fa'
import { FaRegCalendarAlt } from 'react-icons/fa'

import { BiLogInCircle } from 'react-icons/bi'
import ProfileIcon from '../assests/icons/image.png';
import {GoReport}  from 'react-icons/go'
function Navbar() {
  const history = useHistory();
  const location = useLocation();
  // console.log("pathname===>",location.pathname);

  //   window.onscroll = ()=> { 
  //    console.log("scrolling...")
  //     setDropdownOpen(false)
  // } //48.14815139770508

  const [dropdownOpen, setDropdownOpen] = useState(false);

  const toggle = () => setDropdownOpen(prevState => !prevState);

  const [dropdownOpen1, setDropdownOpen1] = useState(false);

  const toggle1 = () => setDropdownOpen1(prevState => !prevState);

  return (
    <div className="mainNav container-fluid px-6 py-auto" /*style={{ paddingInline: "5rem" }}*/>
      <span onClick={() => { history.push('/dashboard') }} className="text-white fw-bolder" style={{ cursor: "pointer" }}><img src={logo} alt="logo" className="locusb-logo" /><span style={{ fontSize: "larger", fontWeight: "bold" }}>LocusB</span></span>
      <div>
        <div className='header-txt my-auto py-2'>
          <span className="navbarElement" onClick={() => { history.push('/dashboard') }} style={{ display: location.pathname === "/dashboard" ? "none" : "block" }}>Home&nbsp;</span>
           {/* <span className="navbarElement" onClick={() => { history.push('/generate-report') }} style={{ display: location.pathname === "/generate-report" ? "none" : "block" }}>Generate Report&nbsp;</span>  */}
   
  
          <span className="navbarElement" onClick={() => { history.push('/help') }} style={{ display: location.pathname === "/help" ? "none" : "block" }}>Help&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
     <div style={{marginRight : "40px"}}>
     <Dropdown isOpen={dropdownOpen1} toggle={toggle1}>
            <DropdownToggle caret className="dropdownmenu">

       <span className="navbarElement1">Reports</span> 
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem className="dropdownitem" onClick={() => {
                  history.push('/custom-generate-report');
                }}><span>
                  
                  <FaRegCalendarAlt size="20px" /></span>
                &nbsp; Custom
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem className="dropdownitem" onClick={() => {
                  history.push('/monthly-generate-report');
                }}><span><FaRegCalendarAlt size="20px" /></span>
                &nbsp; Monthly
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
          </div> 
          <Dropdown isOpen={dropdownOpen} toggle={toggle}>
            <DropdownToggle caret className="dropdownmenu">
              {/* <FaRegUserCircle style={{ stroke: "#2596BE", strokeWidth: "10" }} size={35} fixedWidth /> */}
              <img src={ProfileIcon} style={{color:"white !important"}} height="30px" width="30px" alt="user" />
            </DropdownToggle>
               <DropdownMenu right>
              <DropdownItem className="dropdownitem" onClick={() => {
                  history.push('/my-profile');
                }}><span><FaRegUserCircle size="20px" /></span>
                
                &nbsp;My Profile
              </DropdownItem>
              <DropdownItem divider />
              <DropdownItem className="dropdownitem" onClick={() => {
                toast.success("Succcessfully logged out!");
                history.push('/');
                localStorage.clear();
              }}><BiLogInCircle size="20px" />&nbsp;Sign Out</DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div>
      </div>
    </div>
  );
}

export default Navbar;